import axiosCreator from '../http-common';
import { getToken } from './authentication';


const getAll = async (chainId, siteId, page, type) => {
  const token = await getToken();
  const axios = await axiosCreator(token, true);
  const url = `/api/imagebank/?limit=5&page=${page}&type=${type}&chainId=${chainId}&siteId=${siteId}`;
  const response = await axios.get(url);
  return response.data;
};

const getById = async (imageName, container) => {
  const token = await getToken();
  const axios = await axiosCreator(token);
  const url = `/api/imagebank/${imageName}?container=${container}`;
  const response = await axios.get(url);
  return response.data;
};

const create = async (imageData, imageType, chainId, siteId) => {
  const token = await getToken();
  const axios = await axiosCreator(token, true);
  const headers = { 'content-type': 'multipart/form-data' };
  const options = { headers };
  return await axios.post(`/api/imagebank?type=${imageType}&chainId=${chainId}&siteId=${siteId}`, imageData, options);
};

const remove = async (id, type, chainId, siteId) => {
  try {
    const token = await getToken();
    const axios = await axiosCreator(token);
    return await axios.delete(`/api/imagebank/${id}?type=${type}&chainId=${chainId}&siteId=${siteId}`);
  } catch (err) {
    console.log('image not removed');
  }
};


export default {
  getAll,
  getById,
  create,
  remove,
};
